import { useState, useEffect, useContext } from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import { Button } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import ReactPlayer from "react-player/lazy";
import Link from "@mui/material/Link";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import Box from '@mui/material/Box';

// Component
import PartDisplayModal from "../../../components/partDisplayModal";
import SeoHead from "../../../components/SeoHead";
// import VideosFilter from "../../../components/VideosFilter";
const VideosFilter = dynamic(() => import("../../../components/VideosFilter"));
const EmailSignupPopup = dynamic(() => import("../../../components/EmailSignupPopup"));

// Context maintains search settings across pages
import { SearchContext } from "../../../components/SearchProvider";

// Functions
import api from "../../../functions/api";

function Search({ carMake, carModel, videoData, partDataForOnPageParts, allVideos, allBrands, allParts, allVideosByTrim, links, description }) {
  const router = useRouter();
  const [videosToDisplay, setVideosToDisplay] = useState(allVideos);
  const [partsToDisplay, setPartsToDisplay] = useState(allParts);
  const [partsDataToUse, setPartsDataToUse] = useState(partDataForOnPageParts);
  const [brandsToFilter, setBrandsToFilter] = useState([]);
  const [trimsToFilter, setTrimsToFilter] = useState([]);
  const { make, setMake } = useContext(SearchContext);
  const { model, setModel } = useContext(SearchContext);

  const body = {
    textAlign: "center",
    paddingTop: "40px",
    paddingBottom: "1vh",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "calc(10px + 2vmin)",
  };

  const partsDisplay = {
    paddingTop: "40px",
    paddingBottom: "40px",
  };

  //On page change this updates videos to display and clears filters 
  useEffect(() => {
    setBrandsToFilter([]);
    setTrimsToFilter([]);
    setVideosToDisplay(allVideos);
    setPartsToDisplay(allParts);
    setPartsDataToUse(partDataForOnPageParts)


    // Set search bar parameters, if not set
    if (make == "" && model == "") {
      setMake(carMake);
      setModel(carModel);
    }
  }, [router.pathname, router.query.make, router.query.model]);

  const processVideoFilters = () => {
    // For each video, check if part is part is filtered and if so, remove it

    let newVideosList = [];

    // For each video, check if part is trim is filtered and if so, remove it
    Object.keys(allVideosByTrim).map((trim) => {
      allVideosByTrim[trim].map((video) => {
        let displayVideo = true;

        // Check for brand Filter
        const brandsForVideo = getAllBrandsParts(getAllPartsForVideos([video], videoData), partsDataToUse);
        brandsForVideo.map((brand) => {
          // If brand is not in filter list then it should be rendered
          if (brandsToFilter.includes(brand)) {
            displayVideo = false;
          }
        });

        //Check for Trims filter
        if (trimsToFilter.includes(trim)) {
          displayVideo = false;
        }

        if (displayVideo && !newVideosList.includes(video)) {
          newVideosList.push(video);
        }
      });
    });

    setVideosToDisplay(newVideosList);

    setVideosToDisplay([...newVideosList]);
  };

  const addToBrandsToFilter = (brandName, checked) => {
    if (checked) {
      const index = brandsToFilter.indexOf(brandName);
      brandsToFilter.splice(index, 1);
    } else {
      brandsToFilter.push(brandName);
    }

    processVideoFilters();
  };

  const addToTrimsToFilter = (TrimName, checked) => {
    if (checked) {
      const index = trimsToFilter.indexOf(TrimName);
      trimsToFilter.splice(index, 1);
    } else {
      trimsToFilter.push(TrimName);
    }

    processVideoFilters();
  };

  function PartDisplayInsideVideoWindow(partsList) {
    if (partsList) {
      return partsList.map((part) => {
        if (partsDataToUse.hasOwnProperty(part)) {
          return (
            <PartDisplayModal
              key={`${part}-partDisplayModal`}
              name={partsDataToUse[part]["Name"]}
              link={partsDataToUse[part]["productLink"]}
              brand={partsDataToUse[part]["Brand"]}
              type={partsDataToUse[part]["SystemType"]}
              price={partsDataToUse[part]["Price"]}
              material={partsDataToUse[part]["Material"]}
              mainPipingDiameter={partsDataToUse[part]["MainPipingDiameter"]}
            />
          );
        } else {
          return <Typography>No part found for {part}</Typography>;
        }
      });
    }
  }

  function videoDisplayWindow(VideoName, Name, Video, VideoNotes, partsList) {
    return (
      <Paper elevation={4} sx={{ height: "100%" }}>
        <Card sx={{ height: "100%" }}>
          <CardContent>
            <CardMedia>
              <ReactPlayer url={Video} controls={true} width={"100%"} light={true} />
            </CardMedia>
            {/* <Typography gutterBottom variant="h5" component="div">
              {VideoName}
            </Typography> */}
            <Typography gutterBottom component="div">
              {Name}
            </Typography>
            <Typography gutterBottom component="div">
              {VideoNotes}
            </Typography>
            <Box sx={{ paddingTop: "7px" }}>
              <Typography gutterBottom sx={{ fontSize: "1em" }} variant="overline">
                Parts
              </Typography>
              {PartDisplayInsideVideoWindow(partsList)}
            </Box>
          </CardContent>
        </Card>
      </Paper>
    );
  }

  function ImageDisplay(image,name) {

    if (image) {

      if (typeof(image) == "object") {
        let imageUrl = image[0]
        // console.log("imageUrl:", imageUrl)
        return (
          <Box>
            <img style={{ maxWidth: "100%", maxHeight: "100%" }} alt={name} src={imageUrl} />
          </Box>
        )
      }
    }
  }

  function partDisplayWindow(name, brand, systemType, price, image) {
    const url = `/parts/${encodeURIComponent(name)}`
    return (
      <Link sx={{ textDecoration: "none", color: "unset" }} href={url} target="_blank" rel="noopener" prefetch={false}>
        <Paper elevation={4} sx={{ textAlign: "left", height: "100%" }}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <CardMedia>
                {/* <ReactPlayer url={Video} controls={true} width={"100%"} light={true} /> */}
              </CardMedia>
              <Typography variant="overline">
                {brand}
              </Typography>
              <Typography gutterBottom variant="subtitle1">
                {name}
              </Typography>
              {image && //Conditional rendering for image
                ImageDisplay(image,name)
              }
              {systemType && //Conditional rendering for system type
                <Typography gutterBottom variant="subtitle1">
                  System Type: {systemType}
                </Typography>
              }
              {price && //Conditional rendering for price
                <Typography gutterBottom sx={{ color: "green", fontSize: "1.5rem" }} variant="caption">
                  ${price}
                </Typography>
              }
            </CardContent>
          </Card>
        </Paper>
      </Link>
    );
  }

  const partsGrid = () => {
    // console.log("partsToDisplay", partsToDisplay)
    return partsToDisplay.map((part) => {
      // if (!(videoData[video]["Name"] && videoData[video]["Video"] && videoData[video]["PARTID"])) {
      //   return null;
      // }
      // console.log("partsDataToUse[part]")
      // console.log(partsDataToUse[part])

      let systemType
      if (partsDataToUse[part].hasOwnProperty("SystemType")) {
        systemType = partsDataToUse[part]["SystemType"]
      }

      if (systemType == "Unknown") {
        systemType = null
      }

      return (
        <Grid item xs={6} lg={4} key={`${partsDataToUse[part]["ID"]}-PART_ID`}>
          {partDisplayWindow(
            partsDataToUse[part]["ID"],
            partsDataToUse[part]["Brand"],
            systemType,
            partsDataToUse[part]["Price"],
            partsDataToUse[part]["images"]
          )}
        </Grid>
      );
    });
  };

  const videosGrid = () => {
    return videosToDisplay.map((video) => {
      if (!(videoData[video]["Name"] && videoData[video]["Video"] && videoData[video]["PARTID"])) {
        return null;
      }

      return (
        <Grid item xs={12} lg={6} key={`${videoData[video]["Name"]}-videoId-${video}`}>
          {videoDisplayWindow(
            videoData[video]["VideoName"],
            videoData[video]["Name"],
            videoData[video]["Video"],
            videoData[video]["VideoNotes"],
            videoData[video]["PARTID"]
          )}
        </Grid>
      );
    });
  };

  function descriptionLinks(make, model) {
    // Gate to catch if all params not filled
    if (!(make && model)) {
      return null;
    }

    // Gate to catch if links don't exist
    if (!links) {
      return null;
    }

    // Gate to catch if no links in json doc
    if (!(links.length > 0)) {
      return null;
    }

    return links.map((link) => {
      return (
        <Grid item xs={12} sm={6} key={link["Description"]}>
          <Link noWrap variant="body2" sx={{ color: "text.primary" }} href={link["Link"]} target="_blank" rel="noopener" prefetch={false}>
            <Button sx={{ height: "6vh" }} variant="contained">
              {link["Description"]}
            </Button>
          </Link>
        </Grid>
      );
    });
  }

  function getVideos(make, model, videoData) {
    // Gate to catch if all params not filled
    if (!(make && model)) {
      return null;
    }

    return (
      <div>
        {/* ToDo: Add ability to search by part or by video */}
        <Typography variant="h1" sx={{ fontSize: "2.5rem", paddingBottom: "1vh" }}>
          Discover Your Perfect {carMake} {carModel} Aftermarket Exhaust
        </Typography>
        <Container maxWidth="sm">
          <Grid container sx={{ paddingBottom: "5px" }} spacing={2} direction="row" alignItems="center" justifyContent="center">
            {descriptionLinks(carMake, carModel)}
          </Grid>
          <Typography align="left" sx={{ paddingBottom: "4vh" }}>
            {description}
          </Typography>
        </Container>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={2} key="videos filter">
            <VideosFilter
              videosList={allVideos}
              videosByTrimList={allVideosByTrim}
              brandsList={allBrands}
              addToBrandsToFilter={addToBrandsToFilter}
              brandsToFilter={brandsToFilter}
              trimsToFilter={trimsToFilter}
              addToTrimsToFilter={addToTrimsToFilter}
            />
          </Grid>
          <Grid item xs={12} lg={10} key="videos grid">
            <Typography variant="h2" align="left" sx={{ fontSize: "2rem", paddingBottom: "10px" }}>
              Search Exhaust Components
            </Typography>
            <Grid sx={{ paddingBottom: "20px" }} container spacing={2}>
              {partsGrid()}
            </Grid>
            <Typography variant="h2" align="left" sx={{ fontSize: "2rem", paddingBottom: "10px" }}>
              Search Exhaust Videos and Audio
            </Typography>
            <Grid container spacing={2}>
              {videosGrid()}
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }

  const canonicalLink = `https://searchexhaust.com/search/${carMake}/${carModel}`;
  return (
    <div>
      <SeoHead
        title={`Search Exhaust for your ${carMake} ${carModel} Fast with Video and Audio`}
        description={`Discover your perfect exhaust mod in minutes for your ${carMake} ${carModel} on the worlds largest curated library of aftermarket exhaust audio and video!`}
        canonicalLink={canonicalLink}
      />
      <EmailSignupPopup delaySeconds={90} page={canonicalLink} />
      <Container className="body" sx={body} maxWidth="false" align="center">
        <Container className="partsDisplay" maxWidth="xl">
          {/* <Typography>{allVideos}</Typography>
          <Typography>{videosToDisplay}</Typography> */}
          {getVideos(carMake, carModel, videoData)}
        </Container>
      </Container>
    </div>
  );
}

async function getAllCars() {
  const ddbCallCacheData = await api.cache.get();

  let carPathsList = [];
  //loop of make model object. Path is make/model.
  Object.keys(ddbCallCacheData["cars"]["Items"]).map((car) => {
    const make = ddbCallCacheData["cars"]["Items"][car]["Make"];

    const model = ddbCallCacheData["cars"]["Items"][car]["Model#Trim#Year"].split("#")[0];
    const trim = ddbCallCacheData["cars"]["Items"][car]["Model#Trim#Year"].split("#")[1];
    const year = ddbCallCacheData["cars"]["Items"][car]["Model#Trim#Year"].split("#")[2];

    const videos = ddbCallCacheData["cars"]["Items"][car]["Videos"];

    carPathsList.push({
      params: {
        make: make,
        model: model,
        // trim: trim,
        // year: year,
      },
    });
  });
  return carPathsList;
}

export async function getStaticPaths() {

  // Only re-pull ddb cache if it doesn't exist
  // ToDo, write some quick check if cache needs to be pulled.

  let result = await api.cache.checkCacheExists()
  console.log("DDBCache check result: ", result)

  const paths = await getAllCars();

  return {
    paths,
    fallback: false,
  };
}

function getSpecificCarData(make, model, carData) {
  let specificCarData = {};

  carData["Items"].map((car) => {
    const carMake = car["Make"];
    const carModel = car["Model#Trim#Year"].split("#")[0];
    const carTrim = car["Model#Trim#Year"].split("#")[1];
    // const carYear = car['Model#Trim#Year'].split("#")[2]

    if (make == carMake && model == carModel) {
      specificCarData = car;
    }
  });

  return specificCarData;
}

function getAllVideosAndPartsForCar(make, model, carData) {
  const allVideosList = [];
  const allPartsForCarList = [];
  let videosByTrim = {};
  // console.log("Getting videos and parts for:", make, model);
  carData["Items"].map((car) => {
    const carMake = car["Make"];
    const carModel = car["Model#Trim#Year"].split("#")[0];
    const carTrim = car["Model#Trim#Year"].split("#")[1];
    // const carYear = car['Model#Trim#Year'].split("#")[2]
    if (make == carMake && model == carModel) {
      if (car.hasOwnProperty('Parts')) {
        car["Parts"].map((part) => {
          allPartsForCarList.push(part);
        });
      }

      if (car.hasOwnProperty('Videos')) {
        car["Videos"].map((video) => {
          allVideosList.push(video);
        });
        videosByTrim[carTrim] = car["Videos"];
      }
    }
  });

  return [allVideosList, videosByTrim, allPartsForCarList];
}

function getAllLinksForCar(make, model, carData) {
  const allLinksList = [];

  carData["Items"].map((car) => {
    const carMake = car["Make"];
    const carModel = car["Model#Trim#Year"].split("#")[0];
    const carTrim = car["Model#Trim#Year"].split("#")[1];
    // const carYear = car['Model#Trim#Year'].split("#")[2]

    if (make == carMake && model == carModel && carTrim == "NULL") {
      if ("Links" in car) {
        car["Links"].map((link) => {
          allLinksList.push(link);
        });
      }
    }
  });

  return [...new Set(allLinksList)];
}

function getDescriptionForCar(make, model, carData) {
  // Provide empty description for cars which have none
  let description = "";

  carData["Items"].map((car) => {
    const carMake = car["Make"];
    const carModel = car["Model#Trim#Year"].split("#")[0];
    const carTrim = car["Model#Trim#Year"].split("#")[1];
    // const carYear = car['Model#Trim#Year'].split("#")[2]

    if (make == carMake && model == carModel && carTrim == "NULL") {
      if ("Description" in car) {
        description = car["Description"];
      }
    }
  });
  return description;
}

function getAllPartsForVideos(videosList, videoData) {
  let partsList = [];

  if (videosList.length > 0) {
    videosList.map((video) => {
      if (videoData[video] !== undefined) {
        videoData[video]["PARTID"].map((part) => {
          if (partsList.indexOf(part) === -1) {
            partsList.push(part);
          }
        });
      } else {
        console.error("No video data exists for video: " + video)
      }
    });
  }
  return partsList;
}

function getAllBrandsParts(partsList, partsData) {
  let brandsList = [];


  partsList.map((part) => {
    if (partsData[part]) {
      const brand = partsData[part]["Brand"];

      if (brandsList.indexOf(brand) === -1) {
        brandsList.push(brand);
      }
    } else {
      console.log(`WARNING: Part has no data! ${part}`)
    }
  });

  return brandsList;
}

function getPartDataForOnPageParts(allParts, allPartData) {
  let partsDataDict = {}

  allParts.map((part) => {
    partsDataDict[part] = allPartData[part]
  })

  return partsDataDict
}

//Get staticprops gets called once per path. For every make and model, getstaticprops will be called once.
export async function getStaticProps({ params }) {
  const ddbCallCacheData = await api.cache.get();
  const carData = ddbCallCacheData["cars"];
  const videoData = ddbCallCacheData["videos"];
  const allPartData = ddbCallCacheData["parts"];

  const carMake = params.make;
  const carModel = params.model;

  const [allVideos, allVideosByTrim, allPartsForCarNames] = getAllVideosAndPartsForCar(carMake, carModel, carData);
  const allPartsForVideos = getAllPartsForVideos(allVideos, videoData);
  const allParts = [... new Set(allPartsForVideos.concat(allPartsForCarNames))] // Convert to set ensures parts are unique
  const allBrands = getAllBrandsParts(allParts, allPartData);
  const links = getAllLinksForCar(carMake, carModel, carData);
  const description = getDescriptionForCar(carMake, carModel, carData);

  const partDataForOnPageParts = getPartDataForOnPageParts(allParts, allPartData)

  return {
    props: {
      videoData,
      carData,
      partDataForOnPageParts,
      carMake,
      carModel,
      allVideos,
      allVideosByTrim,
      allParts,
      allBrands,
      links,
      description,
    },
  };
}

export default Search;
